import { Image } from 'foundations-components/transitional/components/Image';
import { TrackingAction, TrackingFeature, TrackingScreen, TrackingSubscreen, trackInteractionWithId } from '../../../app/utils/tracking';
import { PRODUCT_UPDATE_TYPES } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeroImage = ({
  type,
  heroImageUrl,
  callToActionUrl,
  productUpdateId
}) => {
  if (type === PRODUCT_UPDATE_TYPES.NO_IMAGE || !heroImageUrl) {
    return null;
  }
  const image = /*#__PURE__*/_jsx(Image, {
    src: heroImageUrl,
    paddingBlockEnd: "500"
  });
  if (callToActionUrl) {
    return /*#__PURE__*/_jsx("a", {
      onClick: () => trackInteractionWithId(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.UPDATE_PANEL, TrackingFeature.HERO_IMAGE, TrackingAction.CLICK, `product update ID ${productUpdateId}`),
      href: callToActionUrl,
      children: image
    });
  }
  return image;
};